import { apiClient } from './axios';

import type {
  ChatListResponse,
  ChatMessagesResponse,
  ChatQuery,
  DeleteChatResponse,
} from '@repo/shared-types';

export const chatsApi = {
  listChats: async (query?: Partial<ChatQuery>): Promise<ChatListResponse> => {
    const response = await apiClient.get<ChatListResponse>('/chats', {
      params: query,
    });
    return response.data;
  },

  getChatMessages: async (chatId: string): Promise<ChatMessagesResponse> => {
    const response = await apiClient.get<ChatMessagesResponse>(`/chats/${chatId}/messages`);
    return response.data;
  },

  deleteChat: async (chatId: string): Promise<DeleteChatResponse> => {
    const response = await apiClient.delete<DeleteChatResponse>(`/chats/${chatId}`);
    return response.data;
  },
};
